import * as React from 'react';
import Modal from '../modal';
import * as Moment from 'moment';
import { Query, QueryCondition, QueryFilter } from '../../api/apiTypes';
import { DatePickerNoForm } from '../../../forms/informedv2/DatePicker';

interface DateRangeFilterModalProps {
    header: string;
    show: boolean;
    from: string;
    to: string;
    onClose: (event?) => void;
    onChange: (from, to, event?) => void;
    onClear?: () => void;
}

interface GenericDateRangeFilterModalProps {
    query: Query<any>;
    member: string;
    header: string;
    onClose: (values: QueryFilter[]) => void;
    onClear: (member: string) => void;
}

export const GetQueryFilter = (query: Query<any>, member: string, condition: QueryCondition): QueryFilter => {
    return query.Filters.find(filter => filter.Member === member && filter.Condition === condition);
}

export default class DateRangeModal extends React.Component<DateRangeFilterModalProps> {
    render() {
        const { header, show, onClose, onChange, onClear, ...props } = this.props;
        const from = props.from ? Moment(props.from) : null;
        const formattedFromDate = from ? from.format('YYYY-MM-DD') : null;
        const to = props.to ? Moment(props.to) : null;
        const formattedToDate = to ? to.format('YYYY-MM-DD') : null;
        const handleClose = (event?) => onClose(event);
        const handleChange = (from, to, event?) => { onChange(from, to, event); };
        const handleFromChange = (value, event?) => handleChange(value, to, event);
        const handleToChange = (value, event?) => handleChange(from, value, event);
        const handleClear = onClear ? onClear : (event?) => {
            handleChange(null, null, event);
            handleClose(event);
        };
        const format = 'DD-MMM-YYYY';

        return <Modal show={show} closeModalHandler={handleClose} header={header}>
            <div className='modal-body'>
                <div className='row'>
                    <div className='col-md-6 form-group'>
                        <label>From</label>
                        <DatePickerNoForm onChange={handleFromChange} value={formattedFromDate} className='form-control' placeholder={format} from={true} />
                    </div>
                    <div className='col-md-6 form-group'>
                        <label>To</label>
                        <DatePickerNoForm onChange={handleToChange} value={formattedToDate} className='form-control' placeholder={format} from={false} />
                    </div>
                </div>
            </div>
            <div className='modal-footer'>
                <button className='btn btn-primary' onClick={handleClose}>OK</button>
                <button className='btn btn-danger' onClick={handleClear}>Clear</button>
            </div>
        </Modal>
    }
}

export const GenericDateRangeModal = ({ query, member, header, onClose, onClear }: GenericDateRangeFilterModalProps): JSX.Element => {

    const fromFilterValue = GetQueryFilter(query, member, QueryCondition.GreaterThanOrEqual) || { Values: [] };
    const toFilterValue = GetQueryFilter(query, member, QueryCondition.LessThanOrEqual) || { Values: [] };

    const [from, setFrom] = React.useState<string>(fromFilterValue.Values[0]);
    const [to, setTo] = React.useState<string>(toFilterValue.Values[0]);

    return (<DateRangeModal
        header={header + ' Filter'}
        show={true}
        to={to}
        from={from}
        onChange={(_from, _to) => {
            setFrom(_from);
            setTo(_to);
        }}
        onClose={() => {
            onClose(
                [
                    { Member: member, Condition: QueryCondition.GreaterThanOrEqual, Values: !!from ? [from] : [] },
                    { Member: member, Condition: QueryCondition.LessThanOrEqual, Values: !!to ? [to] : [] }
                ]
            );
        }}
        onClear={() => {
            onClear(member);
        }}
    />)
}
